import { Producto } from './Producto';

export class Marca {
    codigoMarca: number;
    nombre: string;
    icono: string;
    listaProductos: Producto[];
    verProductos: Boolean = false;
}